export enum CompanyAttachmentEnum {
  GENERAL = 'LOGO',
  BACKGROUND = 'BACKGROUND',
}
